import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TemplateInput } from '@amzn/mulberry-internal-typescript-client';
import type { SiteManifest } from 'src/utils/siteUtils';

export interface TemplateState {
  template: TemplateInput | null;
  manifest: SiteManifest | null;
  loading: boolean;
  error?: string;
}

const initialState: TemplateState = {
  template: null,
  manifest: null,
  loading: false,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplate: (state, action: PayloadAction<TemplateInput>) => {
      state.template = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    setManifest: (state, action: PayloadAction<SiteManifest>) => {
      state.manifest = action.payload;
    },
    setTemplateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTemplateError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearTemplate: () => initialState,
  },
});

export const { setTemplate, setManifest, setTemplateLoading, setTemplateError, clearTemplate } =
  templateSlice.actions;

export const selectTemplate = (state: { template: TemplateState }) => state.template.template;
export const selectManifest = (state: { template: TemplateState }) => state.template.manifest;
export const selectTemplateLoading = (state: { template: TemplateState }) => state.template.loading;
export const selectTemplateError = (state: { template: TemplateState }) => state.template.error;
export const selectUseTransparentImages = (state: { template: TemplateState }): boolean =>
  !!state.template.template?.useTransparentImages;

export default templateSlice.reducer;
